document.addEventListener('DOMContentLoaded', function () {

  function updateVariantBAUPrice(variantId) {
    var priceEl = document.getElementById('varaintBAUPrice');
    if (!priceEl || !window.varaintBAUPrice) return;

    var price = window.varaintBAUPrice[variantId] || 0;

    if (price == 0) {
      priceEl.style.display = 'none';
      priceEl.innerHTML = '';
    } else {
      priceEl.style.display = 'block';
      priceEl.innerHTML = '$' + price;
    }
  }

  document.addEventListener('theme:variant:change', function(event) {
    if (!event.detail?.variant?.id) return;
    updateVariantBAUPrice(event.detail.variant.id);
  });

  var currentVariantInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
  if (currentVariantInput && currentVariantInput.value) {
    updateVariantBAUPrice(currentVariantInput.value);
  }

  var productRating = document.getElementById('productrating');
  if (productRating) {
    productRating.addEventListener('click', function(e) {
      e.preventDefault();

      const target = document.getElementById(this.getAttribute('data-target'));
      if (!target) return;

      const offsetPosition = target.getBoundingClientRect().top + window.pageYOffset - 80;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    });
  }

});